<template>
  <div>
    <el-alert
      title="同一产品可以有多段生效期。销售计划生成主订单时，取启用且覆盖交期的最近一段单价；没有价目时单价为 0。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.productNumber" clearable placeholder="产品编码" style="width:150px" @keyup.enter.native="search" />
      <el-input v-model="query.productName" clearable placeholder="产品名称" style="width:150px" @keyup.enter.native="search" />
      <el-select v-model="query.active" clearable placeholder="状态" style="width:120px">
        <el-option label="启用" value="1" />
        <el-option label="停用" value="0" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="productNumber" label="产品编码" width="140" />
      <el-table-column prop="productName" label="产品名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="unitPrice" label="单价" width="110" align="right" />
      <el-table-column label="币种" width="90" align="center">
        <template slot-scope="{ row }">{{ currencyLabel(row.currency) }}</template>
      </el-table-column>
      <el-table-column prop="unitName" label="单位" width="80" align="center" />
      <el-table-column prop="dateFrom" label="生效起" width="120" />
      <el-table-column prop="dateTo" label="生效止" width="120" />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.active === '1' ? 'success' : 'info'">{{ row.active === '1' ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.priceId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="form.priceId ? '修改价目' : '新增价目'" :visible.sync="visible" width="560px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px">
        <el-form-item label="产品" required>
          <el-select v-model="form.productId" filterable placeholder="选择产品" style="width:100%" @change="onProduct">
            <el-option v-for="p in products" :key="p.productId" :label="(p.productNumber || '') + ' / ' + (p.productName || '')" :value="p.productId" />
          </el-select>
        </el-form-item>
        <el-form-item label="单价" required>
          <el-input-number v-model="form.unitPrice" :min="0" :precision="4" :controls="false" style="width:100%" />
        </el-form-item>
        <el-form-item label="币种" required>
          <el-select v-model="form.currency" filterable placeholder="请选择币种" style="width:100%">
            <el-option v-for="item in currencies" :key="item.id" :label="item.dictLabel" :value="item.dictValue" />
          </el-select>
        </el-form-item>
        <el-form-item label="单位"><el-input :value="unitLabel" disabled /></el-form-item>
        <el-form-item label="生效起">
          <el-date-picker v-model="form.dateFrom" type="date" value-format="yyyy-MM-dd" style="width:100%" />
        </el-form-item>
        <el-form-item label="生效止">
          <el-date-picker v-model="form.dateTo" type="date" value-format="yyyy-MM-dd" style="width:100%" />
        </el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listPriceList, savePriceList, updatePriceList, deletePriceList } from '../../api/priceList'
import { selectProduct } from '../../api/product'
import { listDictOptions } from '../../api/dict'

function emptyForm() {
  return {
    priceId: '', productId: '', unitPrice: 0, currency: 'CNY', unit: '',
    dateFrom: null, dateTo: null, active: '1', remark: ''
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { productNumber: '', productName: '', active: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, saving: false,
      form: emptyForm(),
      products: [], units: [], currencies: []
    }
  },
  computed: {
    unitLabel() {
      const unit = this.units.find(u => String(u.id) === String(this.form.unit || ''))
      return unit ? unit.dictLabel : (this.form.unit || '')
    }
  },
  created() {
    this.load()
    selectProduct().then(res => { this.products = res.data || [] }).catch(() => {})
    listDictOptions('UNIT').then(res => { this.units = res.data || [] }).catch(() => {})
    listDictOptions('CURRENCY').then(res => { this.currencies = res.data || [] }).catch(() => {})
  },
  methods: {
    currencyLabel(code) {
      const hit = this.currencies.find(c => c.dictValue === code)
      return hit ? hit.dictLabel : (code || '')
    },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listPriceList({
        currentPage: this.page, pageSize: this.pageSize,
        productNumber: this.query.productNumber,
        productName: this.query.productName,
        active: this.query.active
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    onProduct(id) {
      const product = this.products.find(p => p.productId === id)
      this.form.unit = product && product.unit ? String(product.unit) : ''
    },
    openEdit(row) {
      if (!row) {
        this.form = emptyForm()
        this.visible = true
        return
      }
      this.form = {
        priceId: row.priceId,
        productId: row.productId,
        unitPrice: row.unitPrice == null ? undefined : Number(row.unitPrice),
        currency: row.currency || 'CNY',
        unit: row.unit || '',
        dateFrom: row.dateFrom || null,
        dateTo: row.dateTo || null,
        active: row.active || '1',
        remark: row.remark
      }
      this.visible = true
    },
    submit() {
      if (!this.form.productId) {
        this.$message.warning('请选择产品')
        return
      }
      if (!this.form.currency) {
        this.$message.warning('请选择币种')
        return
      }
      if (this.form.unitPrice == null || Number(this.form.unitPrice) < 0) {
        this.$message.warning('请填写单价')
        return
      }
      this.saving = true
      const payload = {
        priceId: this.form.priceId || undefined,
        productId: this.form.productId,
        unitPrice: this.form.unitPrice,
        currency: this.form.currency || undefined,
        unit: this.form.unit || null,
        dateFrom: this.form.dateFrom || null,
        dateTo: this.form.dateTo || null,
        active: this.form.active,
        remark: this.form.remark
      }
      const req = this.form.priceId ? updatePriceList(payload) : savePriceList(payload)
      req.then(() => {
        this.$message.success('已保存')
        this.visible = false
        this.load()
      }).finally(() => { this.saving = false })
    },
    onDelete(id) {
      this.$confirm('确定删除该价目?', '提示', { type: 'warning' }).then(() => {
        deletePriceList([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
